define('models/EvaluationNotification',[
    'lib/knockout',
    'models/User',
    'services/liveDataService',
    'util/ObservableModel'
], function (
    ko,
    User,
    liveDataService,
    ObservableModel
) {
    "use strict";

    var EvaluationNotification = ObservableModel.extend({
        defaults: {
            id: '',
            evaluationId: '',
            conversationId: '',
            evaluatorId: '',
            agentId: '',
            eventTime: '',
            formName: '',
            totalCriticalScore: '',
            totalScore: '',
            redacted: false,
            read: true, // TODO: this needs to be true until a 'read' status on evaluations is determined
            type: 'evaluation'
        }
    }, function () {

        var self = this;

        self.unwrap = function () {
            return ObservableModel.unwrap(self);
        };

        // These property can look different if it comes from a carrier pigeon payload vs public-api payload
        if (!self.agentId() && self.agent) {
            self.agentId(self.agent().id());
        }

        if (!self.conversationId() && self.conversation) {
            self.conversationId(self.conversation().id());
        }

        if (!self.evaluationId()) {
            self.evaluationId(self.id);
        }

        self.createdDate = ko.computed(function () {
            // Saved evaluations will have an assignedDate
            return ko.unwrap(self.assignedDate);

        });
    });

    liveDataService.registerTopic('evaluations', EvaluationNotification);

    return EvaluationNotification;
});

